import React, { useEffect, useRef } from "react";
import scrollToComponent from "react-scroll-to-component";
import Icon from "root/libs/ui-components/src/lib/Icons/Icon";
import PropTypes from "prop-types";
import palletIcon from "icons/cx/pallet.svg";
import containerIcon from "icons/cx/container.svg";
import parcelIcon from "icons/cx/parcel.svg";
import truckIcon from "icons/cx/truck-road-freight.svg";
import { injectIntl } from "react-intl";
import { CATEGORIES } from "one-time-shipment/src/containers/SpotShipmentPage/constants";
import {
  FreightHeadline,
  FreightCardWrapper,
  FreightContent,
  FreightRadioCards,
} from "../styled";

const ICONS = {
  Pallet: palletIcon,
  Containers: containerIcon,
  LooseGoods: parcelIcon,
  Parcel: parcelIcon,
  Truckload: truckIcon,
};
const COPY_ID_PREFIX = "ShipmentLaneComponent.ShipmentCategorySelector";

export const PackageCategorySelector = injectIntl(
  ({ availableCategories, onChange, value, intl }) => {
    const ref = useRef();
    useEffect(() => {
      scrollToComponent(ref.current, {
        offset: -120,
        align: "top",
      });
    }, []);
    const availableCategoriesFiltered = Object.keys(CATEGORIES).filter((key) =>
      availableCategories.includes(CATEGORIES[key])
    );
    return (
      <div className="mx-wrapper">
        <FreightHeadline
          weight="800"
          priority={2}
          ref={ref}
          headlineDisplayType="h"
          className="grid-maxWidthInner no-padding"
        >
          {intl.formatMessage({ id: `${COPY_ID_PREFIX}.Title` })}
        </FreightHeadline>
        <FreightCardWrapper className="no-padding" dimension="biDimensional">
          <FreightContent
            dimension="biDimensional"
            spanMobile="12"
            columnStartMobile="1"
            spanTablet="12"
            columnStartTablet="1"
            spanDesktop="10"
            columnStart="2"
          >
            <FreightRadioCards
              name="shippmentCategory"
              className={
                availableCategoriesFiltered.length > 2 ? "side-by-side " : ""
              }
              value={value}
              onChange={onChange}
              availableColumns={3}
              itemsCount={availableCategoriesFiltered.length}
              options={availableCategoriesFiltered.map((key) => ({
                label: intl.formatMessage({
                  id: `${COPY_ID_PREFIX}.${key}`,
                }),
                value: CATEGORIES[key],
                icon: (
                  <Icon
                    data-testid={ICONS[key].id}
                    icon={ICONS[key]}
                    size="mlarge"
                    useAs="decorative"
                  />
                ),
                description: intl.formatMessage({
                  id: `${COPY_ID_PREFIX}.${key}.Description`,
                }),
              }))}
            />
          </FreightContent>
        </FreightCardWrapper>
      </div>
    );
  }
);
PackageCategorySelector.propTypes = {
  onChange: PropTypes.func,
  value: PropTypes.string,
};
